import { render, staticRenderFns } from "./StudentIcard.vue?vue&type=template&id=2f400067&"
import script from "./StudentIcard.vue?vue&type=script&lang=js&"
export * from "./StudentIcard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports